// extracted by mini-css-extract-plugin
export default {"wrapper":"element_wrapper__aaHyh","image":"element_image__9zaPD","tableFinancial":"element_tableFinancial__CdmAs"};